<template>
        <v-container text-xs-left class="container2" v-bind:class="{mobileheight: isMobile, webheight: !isMobile, containeroverflow : !isMobile}">
          <v-card v-if="item.olfactive_families && item.olfactive_families.length > 0" flat>
            <v-card-text class="pa-0 mt-4" v-bind:class="{'pfo-card-text' : !isMobile, 'pfo-card-text-mobile': isMobile}" >{{olfactive_universe}}</v-card-text>
          </v-card>
          <v-layout row class="wrap-nl notesstyle">

          <v-layout v-if="item.olfactive_families && item.olfactive_families.length > 0" row class="wrap-nl notesstyle" pb-0 mt-4>
              <v-flex text-center v-for="(olfactive_family, index) in item.olfactive_families"  xs4 :key="`base${index}`">
                <v-card flat>
                  <v-tooltip top color="#CA130F">
                    <template v-slot:activator="{ on }">
                      <v-card-text class="pa-0" v-on="on">
                        <img :src="asset_baseurl + olfactive_family.id + '.svg'" class="olf-img" :alt="olfactive_family.name">
                      </v-card-text>
                    <v-flex v-bind:class="{noteName : !isMobile, noteNameMobile: isMobile}">{{olfactive_family.name}}</v-flex>
                    </template>
                    <span>{{olfactive_family.name}}</span>
                  </v-tooltip>
                </v-card>
              </v-flex>
            <v-flex text-center v-for="(olfactive_family, index) in item.olfactive_subfamilies" xs4 :key="`base${index}`">
                <v-card flat>
                  <v-tooltip top color="#CA130F">
                    <template v-slot:activator="{ on }">
                      <v-card-text style="height: 56.5px;" class="pa-0" v-on="on">
                        <img :src="asset_baseurl + olfactive_family.id + '.svg'" class="sub-olf-img" :alt="olfactive_family.name">
                      </v-card-text>
                    <v-flex v-bind:class="{noteName : !isMobile, noteNameMobile: isMobile}">{{olfactive_family.name}}</v-flex>
                    </template>
                    <span>{{olfactive_family.name}}</span>
                  </v-tooltip>
                </v-card>
              </v-flex>
          </v-layout>
          <v-layout v-if="item.olfactive_subfamilies && item.olfactive_subfamilies.length" row class="wrap-nl notesstyle" pb-0>
          </v-layout>

            <v-flex xs12 text-center class="notelabel" v-bind:class="{withcard : !isMobile}">
              <v-card flat>
                <v-card-text class="pa-0" v-bind:class="{'pfo-card-text' : !isMobile, 'pfo-card-text-mobile': isMobile}">{{topnote}}</v-card-text>
              </v-card>
            </v-flex>

            <v-flex text-center v-for="(top_note, index) in item.top_notes" xs4 :key="`top${index}`">
              <v-card flat>
                <v-tooltip top color="#CA130F" z-index="2147483647" class="pfo-tooltip">
                  <template v-slot:activator="{ on }">
                  <v-card-text class="pa-0" v-on="on" text-md-center>
                    <img :src="top_note.thumb_image_url" class="note-img  pfo-attach2">
                  </v-card-text>
                  <v-flex v-bind:class="{noteName : !isMobile, noteNameMobile: isMobile}">{{top_note.name}}</v-flex>
                  </template>
                  <span>{{top_note.name}}</span>
                </v-tooltip>
              </v-card>
            </v-flex>

            <v-flex xs12 text-center class="notelabel" v-bind:class="{withcard : !isMobile}">
              <v-card flat>
                    <v-card-text class="pa-0"  v-bind:class="{'pfo-card-text' : !isMobile, 'pfo-card-text-mobile': isMobile}">{{heartnote}}</v-card-text>
              </v-card>
            </v-flex>

            <v-flex text-center v-for="(heart_note, index) in item.middle_notes" xs4 :key="`heart${index}`">
              <v-card flat>
                <v-tooltip top color="#CA130F">
                  <template v-slot:activator="{ on }">
                    <v-card-text class="pa-0" v-on="on">
                      <img :src="heart_note.thumb_image_url" class="note-img" :alt="heart_note.name"/>
                    </v-card-text>
                  <v-flex v-bind:class="{noteName : !isMobile, noteNameMobile: isMobile}">{{heart_note.name}}</v-flex>
                  </template>
                  <span>{{heart_note.name}}</span>
                  </v-tooltip>
              </v-card>
            </v-flex>

            <v-flex xs12  text-center class="notelabel"  v-bind:class="{withcard : !isMobile}">
              <v-card flat>
                <v-card-text class="pa-0"  v-bind:class="{'pfo-card-text' : !isMobile, 'pfo-card-text-mobile': isMobile}">{{basenote}}</v-card-text>
              </v-card>
            </v-flex>
            <v-flex text-center v-for="(base_note, index) in item.base_notes" xs4 :key="`base${index}`">
              <v-card flat>
                <v-tooltip top color="#CA130F">
                  <template v-slot:activator="{ on }">
                    <v-card-text class="pa-0" v-on="on">
                      <img :src="base_note.thumb_image_url" class="note-img" :alt="base_note.name">
                    </v-card-text>
                  <v-flex v-bind:class="{noteName : !isMobile, noteNameMobile: isMobile}">{{base_note.name}}</v-flex>
                  </template>
                  <span>{{base_note.name}}</span>
                </v-tooltip>
              </v-card>
            </v-flex>

          </v-layout>



              <v-card flat>
                <v-card-text class="pa-0" v-bind:class="{'pfo-card-text' : !isMobile, 'pfo-card-text-mobile': isMobile}" >{{description}}</v-card-text>
              </v-card>
              <v-flex  class='description'>{{item.description}}</v-flex>
        </v-container>

</template>
<script>
  export default {
    name: 'NotesList',

    data() {
      return {
        //topnote: process.env.VUE_APP_TOPNOTE_EN,
        //heartnote: process.env.VUE_APP_HEARTNOTE_EN,
        //basenote: process.env.VUE_APP_BASENOTE_EN
      }
    },
    props: {
      item: null,
      locale: {
        type: String,
        default: () => 'en'
      },
      country: {
        type: String,
        default: () => 'UK'
      },
      isMobile: {
        type: Boolean,
        default: () => false
      }
    },
    computed: {
      topnote() {
        if (this.locale==="en") return process.env.VUE_APP_TOPNOTE_EN
        if (this.locale==="fr") return process.env.VUE_APP_TOPNOTE_FR
        if (this.locale==="es") return process.env.VUE_APP_TOPNOTE_ES
        if (this.locale==="de") return process.env.VUE_APP_TOPNOTE_DE
        if (this.locale==="ja") return process.env.VUE_APP_TOPNOTE_JP
        if (this.locale==="ar") return process.env.VUE_APP_TOPNOTE_AR
        if (this.locale==="pt") return process.env.VUE_APP_TOPNOTE_PT
        if (this.locale==="sv") return process.env.VUE_APP_TOPNOTE_SV
        if (this.locale==="ru") return process.env.VUE_APP_TOPNOTE_RU
        if (this.locale==="tr") return process.env.VUE_APP_TOPNOTE_TR
        if (this.locale==="ms") return process.env.VUE_APP_TOPNOTE_MS
        if (this.locale==="it") return process.env.VUE_APP_TOPNOTE_IT
        if (this.locale==="ko") return process.env.VUE_APP_TOPNOTE_KO
        if (this.locale==="nl") return process.env.VUE_APP_TOPNOTE_NL
        if (this.locale==="th") return process.env.VUE_APP_TOPNOTE_TH
        return process.env.VUE_APP_TOPNOTE_EN
      },
      olfactive_universe() {
        if (this.locale==="en" && process.env.VUE_APP_OLFACTIVE_UNIVERSE_EN) return process.env.VUE_APP_OLFACTIVE_UNIVERSE_EN
        if (this.locale==="fr" && process.env.VUE_APP_OLFACTIVE_UNIVERSE_FR) return process.env.VUE_APP_OLFACTIVE_UNIVERSE_FR
        if (this.locale==="es" && process.env.VUE_APP_OLFACTIVE_UNIVERSE_ES) return process.env.VUE_APP_OLFACTIVE_UNIVERSE_ES
        if (this.locale==="de" && process.env.VUE_APP_OLFACTIVE_UNIVERSE_DE) return process.env.VUE_APP_OLFACTIVE_UNIVERSE_DE
        if (this.locale==="ja" && process.env.VUE_APP_OLFACTIVE_UNIVERSE_JP) return process.env.VUE_APP_OLFACTIVE_UNIVERSE_JP
        if (this.locale==="ar" && process.env.VUE_APP_OLFACTIVE_UNIVERSE_AR) return process.env.VUE_APP_OLFACTIVE_UNIVERSE_AR
        if (this.locale==="pt" && process.env.VUE_APP_OLFACTIVE_UNIVERSE_PT) return process.env.VUE_APP_OLFACTIVE_UNIVERSE_PT
        if (this.locale==="sv" && process.env.VUE_APP_OLFACTIVE_UNIVERSE_SV) return process.env.VUE_APP_OLFACTIVE_UNIVERSE_SV
        if (this.locale==="ru" && process.env.VUE_APP_OLFACTIVE_UNIVERSE_RU) return process.env.VUE_APP_OLFACTIVE_UNIVERSE_RU
        if (this.locale==="tr" && process.env.VUE_APP_OLFACTIVE_UNIVERSE_TR) return process.env.VUE_APP_OLFACTIVE_UNIVERSE_TR
        if (this.locale==="ms" && process.env.VUE_APP_OLFACTIVE_UNIVERSE_MS) return process.env.VUE_APP_OLFACTIVE_UNIVERSE_MS
        if (this.locale==="it" && process.env.VUE_APP_OLFACTIVE_UNIVERSE_IT) return process.env.VUE_APP_OLFACTIVE_UNIVERSE_IT
        if (this.locale==="ko" && process.env.VUE_APP_OLFACTIVE_UNIVERSE_KO) return process.env.VUE_APP_OLFACTIVE_UNIVERSE_KO
        if (this.locale==="nl" && process.env.VUE_APP_OLFACTIVE_UNIVERSE_NL) return process.env.VUE_APP_OLFACTIVE_UNIVERSE_NL
        if (this.locale==="th" && process.env.VUE_APP_OLFACTIVE_UNIVERSE_TH) return process.env.VUE_APP_OLFACTIVE_UNIVERSE_TH
        return process.env.VUE_APP_OLFACTIVE_UNIVERSE_EN
      },
       sub_olfactive_universe() {
        if (this.locale==="en" && process.env.VUE_APP_SUB_OLFACTIVE_UNIVERSE_EN) return process.env.VUE_APP_SUB_OLFACTIVE_UNIVERSE_EN
        if (this.locale==="fr" && process.env.VUE_APP_SUB_OLFACTIVE_UNIVERSE_FR) return process.env.VUE_APP_SUB_OLFACTIVE_UNIVERSE_FR
        if (this.locale==="es" && process.env.VUE_APP_SUB_OLFACTIVE_UNIVERSE_ES) return process.env.VUE_APP_SUB_OLFACTIVE_UNIVERSE_ES
        if (this.locale==="de" && process.env.VUE_APP_SUB_OLFACTIVE_UNIVERSE_DE) return process.env.VUE_APP_SUB_OLFACTIVE_UNIVERSE_DE
        if (this.locale==="ja" && process.env.VUE_APP_SUB_OLFACTIVE_UNIVERSE_JP) return process.env.VUE_APP_SUB_OLFACTIVE_UNIVERSE_JP
        if (this.locale==="ar" && process.env.VUE_APP_SUB_OLFACTIVE_UNIVERSE_AR) return process.env.VUE_APP_SUB_OLFACTIVE_UNIVERSE_AR
        if (this.locale==="pt" && process.env.VUE_APP_SUB_OLFACTIVE_UNIVERSE_PT) return process.env.VUE_APP_SUB_OLFACTIVE_UNIVERSE_PT
        if (this.locale==="sv" && process.env.VUE_APP_SUB_OLFACTIVE_UNIVERSE_SV) return process.env.VUE_APP_SUB_OLFACTIVE_UNIVERSE_SV
        if (this.locale==="ru" && process.env.VUE_APP_SUB_OLFACTIVE_UNIVERSE_RU) return process.env.VUE_APP_SUB_OLFACTIVE_UNIVERSE_RU
        if (this.locale==="tr" && process.env.VUE_APP_SUB_OLFACTIVE_UNIVERSE_TR) return process.env.VUE_APP_SUB_OLFACTIVE_UNIVERSE_TR
        if (this.locale==="ms" && process.env.VUE_APP_SUB_OLFACTIVE_UNIVERSE_MS) return process.env.VUE_APP_SUB_OLFACTIVE_UNIVERSE_MS
        if (this.locale==="it" && process.env.VUE_APP_SUB_OLFACTIVE_UNIVERSE_IT) return process.env.VUE_APP_SUB_OLFACTIVE_UNIVERSE_IT
        if (this.locale==="ko" && process.env.VUE_APP_SUB_OLFACTIVE_UNIVERSE_KO) return process.env.VUE_APP_SUB_OLFACTIVE_UNIVERSE_KO
        if (this.locale==="nl" && process.env.VUE_APP_SUB_OLFACTIVE_UNIVERSE_NL) return process.env.VUE_APP_SUB_OLFACTIVE_UNIVERSE_NL
        if (this.locale==="th" && process.env.VUE_APP_SUB_OLFACTIVE_UNIVERSE_TH) return process.env.VUE_APP_SUB_OLFACTIVE_UNIVERSE_TH
        return process.env.VUE_APP_SUB_OLFACTIVE_UNIVERSE_EN
      },
      description() {
        if (this.locale==="en" && process.env.VUE_APP_PERFUME_DESCRIPTION_EN) return process.env.VUE_APP_PERFUME_DESCRIPTION_EN
        if (this.locale==="fr" && process.env.VUE_APP_PERFUME_DESCRIPTION_FR) return process.env.VUE_APP_PERFUME_DESCRIPTION_FR
        if (this.locale==="es" && process.env.VUE_APP_PERFUME_DESCRIPTION_ES) return process.env.VUE_APP_PERFUME_DESCRIPTION_ES
        if (this.locale==="de" && process.env.VUE_APP_PERFUME_DESCRIPTION_DE) return process.env.VUE_APP_PERFUME_DESCRIPTION_DE
        if (this.locale==="ja" && process.env.VUE_APP_PERFUME_DESCRIPTION_JP) return process.env.VUE_APP_PERFUME_DESCRIPTION_JP
        if (this.locale==="ar" && process.env.VUE_APP_PERFUME_DESCRIPTION_AR) return process.env.VUE_APP_PERFUME_DESCRIPTION_AR
        if (this.locale==="pt" && process.env.VUE_APP_PERFUME_DESCRIPTION_PT) return process.env.VUE_APP_PERFUME_DESCRIPTION_PT
        if (this.locale==="sv" && process.env.VUE_APP_PERFUME_DESCRIPTION_SV) return process.env.VUE_APP_PERFUME_DESCRIPTION_SV
        if (this.locale==="ru" && process.env.VUE_APP_PERFUME_DESCRIPTION_RU) return process.env.VUE_APP_PERFUME_DESCRIPTION_RU
        if (this.locale==="tr" && process.env.VUE_APP_PERFUME_DESCRIPTION_TR) return process.env.VUE_APP_PERFUME_DESCRIPTION_TR
        if (this.locale==="ms" && process.env.VUE_APP_PERFUME_DESCRIPTION_MS) return process.env.VUE_APP_PERFUME_DESCRIPTION_MS
        if (this.locale==="it" && process.env.VUE_APP_PERFUME_DESCRIPTION_IT) return process.env.VUE_APP_PERFUME_DESCRIPTION_IT
        if (this.locale==="ko" && process.env.VUE_APP_PERFUME_DESCRIPTION_KO) return process.env.VUE_APP_PERFUME_DESCRIPTION_KO
        if (this.locale==="nl" && process.env.VUE_APP_PERFUME_DESCRIPTION_NL) return process.env.VUE_APP_PERFUME_DESCRIPTION_NL
        if (this.locale==="th" && process.env.VUE_APP_PERFUME_DESCRIPTION_TH) return process.env.VUE_APP_PERFUME_DESCRIPTION_TH
        return process.env.VUE_APP_PERFUME_DESCRIPTION_EN
      },
      heartnote() {
        if (this.locale==="en") return process.env.VUE_APP_HEARTNOTE_EN
        if (this.locale==="fr") return process.env.VUE_APP_HEARTNOTE_FR
        if (this.locale==="es") return process.env.VUE_APP_HEARTNOTE_ES
        if (this.locale==="de") return process.env.VUE_APP_HEARTNOTE_DE
        if (this.locale==="ja") return process.env.VUE_APP_HEARTNOTE_JP
        if (this.locale==="ar") return process.env.VUE_APP_HEARTNOTE_AR
        if (this.locale==="sv") return process.env.VUE_APP_HEARTNOTE_SV
        if (this.locale==="ru") return process.env.VUE_APP_HEARTNOTE_RU
        if (this.locale==="tr") return process.env.VUE_APP_HEARTNOTE_TR
        if (this.locale==="ms") return process.env.VUE_APP_HEARTNOTE_MS
        if (this.locale==="it") return process.env.VUE_APP_HEARTNOTE_IT
        if (this.locale==="ko") return process.env.VUE_APP_HEARTNOTE_KO
        if (this.locale==="nl") return process.env.VUE_APP_HEARTNOTE_NL
        if (this.locale==="th") return process.env.VUE_APP_HEARTNOTE_TH
        return process.env.VUE_APP_HEARTNOTE_EN
      },
      basenote() {
        if (this.locale==="en") return process.env.VUE_APP_BASENOTE_EN
        if (this.locale==="fr") return process.env.VUE_APP_BASENOTE_FR
        if (this.locale==="es") return process.env.VUE_APP_BASENOTE_ES
        if (this.locale==="de") return process.env.VUE_APP_BASENOTE_DE
        if (this.locale==="ja") return process.env.VUE_APP_BASENOTE_JP
        if (this.locale==="ar") return process.env.VUE_APP_BASENOTE_AR
        if (this.locale==="pt") return process.env.VUE_APP_BASENOTE_PT
        if (this.locale==="sv") return process.env.VUE_APP_BASENOTE_SV
        if (this.locale==="ru") return process.env.VUE_APP_BASENOTE_RU
        if (this.locale==="tr") return process.env.VUE_APP_BASENOTE_TR
        if (this.locale==="ms") return process.env.VUE_APP_BASENOTE_MS
        if (this.locale==="it") return process.env.VUE_APP_BASENOTE_IT
        if (this.locale==="ko") return process.env.VUE_APP_BASENOTE_KO
        if (this.locale==="nl") return process.env.VUE_APP_BASENOTE_NL
        if (this.locale==="th") return process.env.VUE_APP_BASENOTE_TH
        return process.env.VUE_APP_BASENOTE_EN
      },
      asset_baseurl() {
        return process.env.VUE_APP_ASSET_BASE_URL
      }
    }
  }
</script>
<style scoped>
  .orders2-layout{
    position: relative;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0%;
    height: 90px;
    overflow-y: scroll;
  }
  .noteNameMobile {
    color: rgba(30,30,30,0.7);
    font-size: 12px;
  }
  .noteName {
    color: rgba(30,30,30,0.7);
  }
  .description {
    padding: 15px;
    padding-left: 30px;
    padding-right: 30px;
    text-align: justify;
    color: rgba(30,30,30,0.7);
  }
  .overflow-hidden {
    overflow: hidden;
  }
  .note-img {
    height: 50px;
    display: inline;
  }
  .olf-img {
    height: 50px;
    display: inline;
  }
  .sub-olf-img {
    height: 35px;
    display: inline;

  }
  .wrap-nl {
    flex-wrap: wrap;
  }
  .notesstyle {
    padding-left: 4px !important;
    padding-right: 4px !important;
    margin-left: auto !important;
    margin-right: auto !important;
    width: 70%;
    padding-bottom: 20px;
    justify-content: center;
  }
  .notelabel {
    margin-top: 16px;
    margin-bottom: 8px;
    padding: 0;
    font-size: 20px;
  }
  .container2 {
    margin: unset;
    padding-top: 0 !important;
    padding-bottom: 0 !important;
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
  .containeroverflow {
    overflow-y: scroll;
  }
  .withcard {
    border-radius:5px;
  }
  .webheight {
    height: 360px;
  }
  .mobileheight {
    height: 10px;
  }
  .row {
    margin-left: unset;
    margin-right: unset;
  }
  .pfo-card-text {
    font-size: 22px;
    text-align: center !important;
  }
  .pfo-sub-card-text {
    font-size: 20px;
  }
  .pfo-card-text-mobile {
    font-size: 16px;
    text-align: center !important;
  }
  .pfo-tooltip {
    top: 100px;
    left: 50px;
    position: relative;
  }
  </style>